import styled from '@emotion/styled/macro';
import {
  Card,
  Typography,
} from '@mui/material';
import UploadIcon from '@mui/icons-material/UploadFile';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useState, useEffect } from 'react';

const UploadCard = styled(Card)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  border: '2px dashed #ccc',
  borderRadius: '8px',
  cursor: 'pointer',
  textAlign: 'center',
  transition: `border-color 200ms ease`,
  '&:hover': {
    borderColor: '#1976d2',
    backgroundColor: '#fafafa'
  }
}));

const UploadInput = styled('input')({
  display: 'none'
});

const UploadLabel = styled('label')({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '24px',
  cursor: 'pointer'
});

const UploadText = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: '0.9rem',
  color: '#555',
  marginTop: '8px',
  textAlign: 'center'
}));

const ErrorText = styled(Typography)(() => ({
  fontSize: '0.75rem',
  color: 'red',
  marginTop: '6px',
  textAlign: 'center'
}));

const SuccessText = styled(Typography)(() => ({
  fontSize: '0.75rem',
  color: 'green',
  marginTop: '6px',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  gap: '4px'
}));

const UploadFileCard = ({ onFileSelect, resetSignal }) => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [fileName, setFileName] = useState('');

  useEffect(() => {
    // Reset ao mudar de step
    setError('');
    setSuccess(false);
    setFileName('');
  }, [resetSignal]);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      if (file.size > 4 * 1024 * 1024) {
        setError('O ficheiro excede os 4MB permitidos.');
        setSuccess(false);
        setFileName('');
        return;
      }

      setSuccess(true);
      setFileName(file.name);
      setError('');
      onFileSelect?.(file); // vai esperar 500ms no parent
    }
  };

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <UploadCard>
      <UploadLabel htmlFor="file-upload-card">
        <UploadIcon fontSize="large" />
        <UploadText>Carregar ficheiro<br />(máx. 4MB)</UploadText>
        <UploadInput
          id="file-upload-card"
          type="file"
          accept=".jpg,.jpeg,.png,.pdf,.svg"
          onChange={handleFileChange}
        />
        {error && <ErrorText>{error}</ErrorText>}
        {success && (
          <SuccessText>
            <CheckCircleIcon fontSize="small" /> Ficheiro carregado com sucesso!
          </SuccessText>
        )}
        <UploadText>{fileName}</UploadText>
      </UploadLabel>
    </UploadCard>
  );
};

export default UploadFileCard;
